<template>
  <CModal
    title="Detalle del Pedido"
    color="info"
    size="lg"
    :show.sync="showModal"
  >
    <div v-if="selectedItem">
      <CRow>
        <CCol md="4" class="text-center">
          <img :src="selectedItem.image_filename ? selectedItem.image_filename : 'no-image.jpg'" class="detail-image">
        </CCol>
        <CCol md="8">
          <div class="detail-name">{{ selectedItem.name }}</div>
          <div class="detail-description">{{ selectedItem.description }}</div>
          <div class="detail-meta mt-2">
            <b>Costo:</b> {{ selectedItem.points | number }} puntos
          </div>
          <div class="detail-meta">
            <b>Fecha de pedido:</b> {{ selectedItem.date | date }}
          </div>
          <div class="detail-meta">
            <b>Estatus:</b>
            <span :class="selectedItem.is_paid ? 'text-success' : 'text-warning'">
              {{ selectedItem.is_paid ? 'Entregado' : 'Pendiente de entrega' }}
            </span>
          </div>
          <div class="detail-meta" v-if="selectedItem.is_paid && selectedItem.delivered_date">
            <b>Fecha de entrega:</b> {{ selectedItem.delivered_date }}
          </div>
        </CCol>
      </CRow>

      <hr>

      <h5 class="font-weight-bold mb-3">Seguimiento</h5>

      <div v-if="loadingTracking" class="text-center py-2">Cargando seguimiento...</div>

      <template v-else>
        <div v-if="tracking.length > 0">
          <div
            v-for="track in tracking"
            :key="track.id"
            class="timeline-item"
          >
            <div class="timeline-dot"></div>
            <div class="timeline-content">
              <strong class="tracking-date">{{ track.created_at | date }}</strong>
              <div class="tracking-comment mt-1">{{ track.comment }}</div>
              <div v-if="track.image" class="mt-2">
                <img :src="track.image" class="tracking-image">
              </div>
            </div>
          </div>
        </div>

        <div v-else>
          <div v-if="selectedItem.is_paid" class="text-success font-weight-bold">
            El producto ya fue entregado {{ selectedItem.delivered_date ? 'el ' + selectedItem.delivered_date : '' }}.
          </div>
          <div v-else class="text-warning font-weight-bold">
            Pendiente de entrega.
          </div>
        </div>
      </template>
    </div>

    <template #footer>
      <CButton color="secondary" @click="closeModal">Cerrar</CButton>
    </template>
  </CModal>
</template>

<script>
import awards_ws from '../../services/awards'

export default {
  name: 'RedeemedAwardDetailModal',
  data () {
    return {
      showModal: false,
      selectedItem: null,
      tracking: [],
      loadingTracking: false
    }
  },
  methods: {
    async open (item) {
      this.selectedItem = item
      this.showModal = true
      await this.loadTracking(item.exchange_id)
    },
    async loadTracking (exchangeId) {
      this.loadingTracking = true
      this.tracking = []

      const response = await awards_ws.getTracking(exchangeId)

      if (response.type === 'success') {
        this.tracking = response.data
      }

      this.loadingTracking = false
    },
    closeModal () {
      this.showModal = false
      this.selectedItem = null
      this.tracking = []
    }
  }
}
</script>

<style scoped>
.detail-image {
  max-width: 100%;
  max-height: 180px;
  border-radius: 6px;
}

.detail-name {
  font-size: 15px;
  font-weight: bold;
}

.detail-description {
  margin-top: 8px;
}

.detail-meta {
  margin-top: 6px;
}

.timeline-item {
  position: relative;
  padding-left: 20px;
  margin-bottom: 15px;
}

.timeline-dot {
  position: absolute;
  left: 0;
  top: 5px;
  width: 10px;
  height: 10px;
  background: #39f;
  border-radius: 50%;
}

.tracking-date,
.tracking-comment {
  font-size: 13px;
}

.tracking-image {
  max-width: 120px;
  border-radius: 4px;
}
</style>